<template>
	<section class="editor-from">
		<div class="header">
			<div style="font-size:18px;font-weight: bold;">审批</div>
			<div style="line-height:40px">
				<el-button type='success' size='mini' @click="check(3)">通过</el-button>
				<el-button type='danger' size='mini' @click="check(4)">驳回</el-button>
				<el-button type='primary' size='mini' @click="back()">关闭</el-button>
			</div>
		</div>
		<ql-toolbar ref="toolbarRef">
			<template v-slot:middle>
				<ql-content-save :key="doc.id" :getContentId="getProposalContentId" ref="contentSaveRef" />
			</template>
			<template v-slot:right>
				<i style="margin-right:20px;font-size:16px;cursor: pointer;" class="el-icon-printer"
					@click="$refs.printViewRef.print(doc.id)" />
				<record-action v-if="inited" :docId="doc.id" :commands="['exportPdf']" style="margin-right:30px" />
			</template>
		</ql-toolbar>
		<div class="contain" v-if="inited" v-loading="loading" element-loading-text="正在加载中">
			<div class="content" id="quill-scroll-contain">
				<div class="article" id='article'>
					<div v-if="doc.headerImage" class="article-header">
						<el-image :src="doc.headerImage" class="header-image" fit="cover" />
					</div>
					<h1 class="doc-title">{{doc.title}}</h1>
					<div style="position: relative">
						<ql-editor ref="checkEditorRef" style="padding:0 15px" />
						<ql-annotation ref="annotationRef" @change="$refs.recordAllTagsRef.getAllTags()" />
					</div>
					<div style="margin:10px 30px">
						<record-all-tags v-if="doc.id" :docId="doc.id" ref="recordAllTagsRef" />
					</div>
					<div style="margin:10px 30px 0 30px">
						<div class="header-title">审阅意见</div>
						<ql-editor key="proposal" ref="proposalRef" class="proposal-editor" />
					</div>
					<div style="padding:10px 0px">
						<approve-history v-if="doc.id" :editState="true" :docId="doc.id" style="padding:0 30px" />
					</div>
				</div>
				<record-student-tag ref="recordStudentTagRef" />
			</div>
		</div>
		<record-print ref="printViewRef" />
	</section>
</template>

<script>
	import { documentApi, approveApi, proposalApi } from '@/boot-api/record'
	import ApproveHistory from './approve-history.vue'
	import RecordAllTags from '@/views/record/student-tag/record-all-tags.vue'
	import RecordStudentTag from '@/views/record/student-tag/record-student-tag.vue'
	import '../record-common.scss'
	import RecordAction from '@/views/record/record-action.vue'
	import RecordPrint from '../record-print.vue'

	export default {
		components: { ApproveHistory, RecordAllTags, RecordStudentTag, RecordAction, RecordPrint },
		data() {
			return {
				doc: {
					headerImage: ''
				},
				folderId: 0,

				status: 'add',
				showTplList: false,
				headerImageId: 0,
				/**
				 * 当前的审批信息
				 * @type {{message:string,status:{code:number,description:string}}}
				 */
				approveInfo: {},
				id: 0,
				loading: false,
				// 是否已经初始化完成了
				inited: false,
				resize: false,// 调整布局居中
				allStudentTagIds: [],
				proposal: null
			}
		},
		methods: {
			async open(id) {

				this.loading = true
				this.inited = false
				this.id = id
				this.doc = { headerImage: '' }
				this.folderId = 0
				this.resize = false

				const approveResult = await approveApi.getInfo({ id });
				this.approveInfo = approveResult.data
				await this.getInfo(this.approveInfo.docId)
				// 获取实录基本信息
				await this.$store.dispatch('record/getRecordInfo', this.doc.id)
				this.$store.commit('record/setModel', 'check')
				// 初始化评审意见的编辑器
				this.proposal = await proposalApi.getProposal({ docId: this.approveInfo.docId, contentType: 1 }).then(res => res.data)
				this.inited = true
				this.$nextTick(_ => {
					// 初始化实录的内容
					const quill = this.$refs.checkEditorRef.init({ toolbar: false, enable: false })
					if (this.doc.type && this.doc.type == 'delta') {
						this.$refs.checkEditorRef.setOps(this.doc.ops)
					} else {
						this.$refs.checkEditorRef.setHtml(this.doc.content)
					}
					this.$refs.annotationRef.init(quill, this.approveInfo.docId)
					const proposalQuill = this.$refs.proposalRef.init({
						toolbar: true,
						ops: this.proposal ? this.proposal.ops : null,
						placeholder: '请输入审阅意见'
					})
					this.$refs.contentSaveRef.init(proposalQuill)
					this.loading = false
				})

				


			},
			/**
			 * 返回上一页
			 */
			back() {
				if (['/login', '/', ''].some(v => v == this.fromPath)) {
					this.$router.replace({ path: "/record/approve/index" })
				} else {
					this.$router.back()
				}
			},

			async getInfo(id) {
				const res = await documentApi.getDetail({ id })
				this.doc = res.data
				if (this.doc.ops) {
					this.doc.ops = this.doc.ops.map(op => {
						if (op.embed) {
							op.insert = JSON.parse(op.embed)
						}
						delete op.embed
						return op
					})
				}
				this.headerImageId = this.doc.imageId

			},
			approveCommit() {
				approveApi.commit({ docId: this.doc.id }).then(res => {
					this.$message.success('提交成功')
				})
			},
			check(action) {
				this.$prompt('请输入审批意见', '提示', {
					inputType: 'textarea',
					inputValue: this.approveInfo.message,
					inputMaxlength: 120
				}).then(({ value }) => {
					approveApi.approve({ id: this.id, message: value, status: action }).then(res => {
						this.$message.success('审批成功')
						this.$emit('change')
					})
				}).catch(() => { })
			},
			async getProposalContentId() {
				const contentId = await proposalApi.getContentId({ docId: this.doc.id }).then(res => res.data)
				console.log('contentId', contentId)
				return contentId
			}


		},
		beforeDestroy() {
			this.$store.commit('record/resetRecordInfo')
		},
		mounted() {
			const id = this.$route.query.id
			this.open(id)

		}
	}
</script>

<style lang="scss" scoped>
	.folder-path {
		width: 300px;
		margin-left: 6px;
	}
	.folder-path /deep/ .el-input__inner {
		border: none;
		font-size: 16px;
		font-weight: bold;
		color: #303133;
		background-color: #fafafa;
		vertical-align: middle;
		padding: 0;
	}

	.proposal-editor {
		margin-top: 20px;
		border: 1px solid #dcdfe6;
		border-radius: 5px;
		min-height: 150px;
	}

	.header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		height: 50px;
		padding: 0 10px;
	}
	.content {
		height: calc(100% - 100px);
		overflow: auto;
	}
	.contain {
		position: relative;
	}
	.editor-from /deep/ .custom-class {
		background-color: #fafafa;
		overflow: hidden;
	}
	.editor-from /deep/ .el-dialog__header {
		padding: 10px;
	}
	.editor-from /deep/ .el-dialog__body {
		padding: 0;
		color: #000;
	}
	.article.left {
		margin-right: calc(50% - 400px + 150px);
	}
	.article {
		position: relative;
		border: 1px solid #e8e8e8;
		width: 800px;
		margin-right: auto;
		margin-left: auto;
		margin-bottom: 20px;
		margin-top: 20px;
		min-height: 1000px;
		background-color: white;
		.article-header {
			position: relative;
			.btns {
				position: absolute;
				bottom: 10px;
				right: 30px;
			}
		}
		.title {
			width: 100%;
			border: none;
			outline: none;
			font-size: 20px;
			font-weight: bold;
			padding: 10px 30px;
		}
		.header-image-btn {
			margin: 50px 0 0 30px;
		}
		.header-image {
			height: 220px;
			width: 100%;
		}
	}
	.temple-list {
		width: 100%;
		position: fixed;
		z-index: 999;
		bottom: 0;
	}

	.ql-toolbar.ql-snow {
		border: none;
		border-top: 1px solid #e4e7ed;
		padding: 1px;
	}
	.proposal {
		height: 200px;
		width: 200px;
	}
</style>


// WEBPACK FOOTER //
// src/views/record/approve/approve-editor.vue